import React, { createContext, useContext, useReducer } from "react";
import { initialState, conveniosReducer, ConveniosState } from "./convenios-reducer";

type ConveniosContextType = {
    state: ConveniosState;
    dispatch: React.Dispatch<any>;
};

const ConveniosContext = createContext<ConveniosContextType | undefined>(undefined);

export const ConveniosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(conveniosReducer, initialState);

    return (
        <ConveniosContext.Provider value={{ state, dispatch }}>
            {children}
        </ConveniosContext.Provider>
    );
};

export const useConveniosState = () => {
    const context = useContext(ConveniosContext);
    if (!context) {
        throw new Error("useConveniosState must be used within ConveniosProvider");
    }
    return context.state;
};

export const useConveniosDispatch = () => {
    const context = useContext(ConveniosContext);
    if (!context) {
        throw new Error("useConveniosDispatch must be used within ConveniosProvider");
    }
    return context.dispatch;
};
